 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		3: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		3: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","8":"component/app-element-styles","9":"component/apps-grid-styles","10":"component/comment-styles","11":"component/discussion-card-styles","12":"component/editor-quill","13":"component/editor-styles","14":"component/file-form-element-styles","15":"component/file-preview-element-styles","16":"component/file-thumbnail-element-styles","17":"component/footer-element-styles","18":"component/item-selector-element-styles","19":"component/member-menu-styles","20":"component/mobile-sidenav-element-styles","21":"component/not-found-element-styles","22":"component/promo-banner-styles","23":"component/resource-builder-element-styles","24":"component/resource-builder-guide-styles","25":"component/resource-cover-styles","26":"component/resource-delete-dialog-styles","27":"component/resource-element-styles","28":"component/resource-toolbar-element-styles","29":"component/resource-type-card-new-element-styles","30":"component/search-element-styles","31":"component/search-no-results-styles","32":"component/settings-dialog-element-styles","33":"component/subject-selector-element-styles","34":"component/tags-element-styles","35":"component/tree-selector-element-styles","38":"postscribe"}[chunkId]||chunkId) + "." + {"0":"59568a6b0af1440894a7","1":"67b27924b2ef02d5b229","2":"a0ad080a5d7c9ef1cc7a","4":"84fa1f923db6708a08f7","5":"663404b8033eef1dfe85","6":"e4c08ee672dc4f80c8ce","7":"34056125629f2b8c915d","8":"ce7d50cd9d92aa56bce1","9":"b92fc0cf7c7b2c78eb84","10":"0012ca92c03ea52e7dda","11":"4a33bdc96d1a8b230679","12":"c0ee8859291e6ddaa021","13":"d806a05fb6c3ad587487","14":"412a8d42d4955e1e3a01","15":"c18074a14cf6946229f7","16":"49f4ebfecaafd1d67ce0","17":"6aecb2e60724ac39a4c7","18":"f552253b8c119742ba62","19":"e89e3869f392ca93cc9a","20":"d7d3f237c24e9c07e00b","21":"f41baf183082dd77bc29","22":"5abbc2d5737c87437616","23":"764b655e454d090be295","24":"1e4e1cd55f74ee65feed","25":"c0a24cd2f84347defbea","26":"ac1db2da11e5b6a8ad1f","27":"993a6d8a4d9465c21345","28":"a231a4c87a1d02850e6c","29":"b13ff003dcb169376ac5","30":"60ab178a092178ee3332","31":"6ef6d0b85ca3a2fa140b","32":"ea294b866101fb35f247","33":"1c9b7827657f9766515f","34":"bce93f58efebdc50020a","35":"cb70e4d540755ad0caa0","38":"066a83cd5d37203fdd82","41":"5c5fe922b3a2a6801afd","42":"4a31559a7192bb119593","43":"31e1e7975b763f5d4a40","44":"0ecff5366974c3b15000","45":"214454a611be86e4d088","46":"279f66a0d715ac742f98","47":"ba1c8ec751edfe52106a","48":"89e4c681c3e2dd82c3d7","49":"2328e4c69285f7304af8","50":"e7f8f3d87a0249b7446b","51":"6aaa5028d5013378c374","52":"7e18dfeb4c9872dfb580","53":"fe899437e367e25cb4e7","54":"f665281e2506f27fe64a","55":"8dea13bca8886bbc59de","56":"07595afbbb559738d1b4"}[chunkId] + ".esm.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"2":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"common","8":"component/app-element-styles","9":"component/apps-grid-styles","10":"component/comment-styles","11":"component/discussion-card-styles","12":"component/editor-quill","13":"component/editor-styles","14":"component/file-form-element-styles","15":"component/file-preview-element-styles","16":"component/file-thumbnail-element-styles","17":"component/footer-element-styles","18":"component/item-selector-element-styles","19":"component/member-menu-styles","20":"component/mobile-sidenav-element-styles","21":"component/not-found-element-styles","22":"component/promo-banner-styles","23":"component/resource-builder-element-styles","24":"component/resource-builder-guide-styles","25":"component/resource-cover-styles","26":"component/resource-delete-dialog-styles","27":"component/resource-element-styles","28":"component/resource-toolbar-element-styles","29":"component/resource-type-card-new-element-styles","30":"component/search-element-styles","31":"component/search-no-results-styles","32":"component/settings-dialog-element-styles","33":"component/subject-selector-element-styles","34":"component/tags-element-styles","35":"component/tree-selector-element-styles","38":"postscribe"}[chunkId]||chunkId) + "." + {"0":"96c89a797161c9fe7aeb","1":"31d6cfe0d16ae931b73c","2":"0867641be6bb7a331283","4":"31d6cfe0d16ae931b73c","5":"5e4b0b24f632afcea7c0","6":"4fff0de743b5b038fb87","7":"84840ce16607c3ad2a35","8":"6545f864fb56851c020d","9":"fd2606858f7ad095faf9","10":"0e8562d6297991a7757c","11":"fe050e4b26da2d9fe24b","12":"31d6cfe0d16ae931b73c","13":"1e7e501a4f7560c8fc52","14":"194c76efabaf7e664cdc","15":"fdec375f7548757c3652","16":"9eb7ddee24b31d40d635","17":"2bd4c920dc83599f9ebf","18":"5d77a943d9f95a8ea88b","19":"2cb68aaf3d7c1688794a","20":"e078b720ea8d323f7274","21":"1f1bd7a3261664b4be5b","22":"21b0346baf5ddb6dc407","23":"4d7fec0219524cbb9db1","24":"2c13c42fb189a35e98d0","25":"cb5a2b660a7ee9cfb383","26":"89cea33db63286d52548","27":"0f00aa1cab644c74cc66","28":"81c914992f0bc8065037","29":"fbbb10516d8aedba5462","30":"28f568b670ee007c6d78","31":"406109ccf76eadee0307","32":"2e67414f1f5d34aa1fc1","33":"9660ad249575b7fe2de0","34":"fc187a0a8bf33e02d702","35":"5d3f157673313806c650","38":"31d6cfe0d16ae931b73c","41":"7561513f8dd60b8e44cf","42":"0029051625870bb1e41c","43":"0e2527e33d652f02b209","44":"60a3e8fb99d334a1b457","45":"b6aac7f30d565276f61d","46":"c5d04195cdce1c68bc48","47":"6685a07c74e679079dd6","48":"e70ddd4d5d6aa5216b98","49":"1e0a3cc8bba482de29b3","50":"7f0393d98087ae4767af","51":"cf323de518ab367aed75","52":"45d79b55cab197aef445","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"6": [
 				27,
 				28
 			],
 			"55": [
 				27,
 				28
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "ui/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
